import { compose } from 'lodash/fp'
import { withTranslation } from 'react-i18next'
import AccountOptions from './AccountOptions'
import withState from './withState'

export default compose(
  withState,
  withTranslation(),
)(AccountOptions)
